"use strict";

exports.__esModule = true;
exports.defaultOptions = exports.runQuery = exports.writeFile = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _fs = require("fs");

var _fs2 = _interopRequireDefault(_fs);

var _pify = require("pify");

var _pify2 = _interopRequireDefault(_pify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var writeFile = exports.writeFile = (0, _pify2.default)(_fs2.default.writeFile);

var runQuery = exports.runQuery = function runQuery(handler, query) {
  return handler(query).then(function (r) {
    if (r.errors) {
      throw new Error(r.errors.join(", "));
    }

    return r.data;
  });
};

var defaultOptions = {
  // Override if you want to manually specify the RSS "generator" tag.
  generator: "GatsbyJS",

  // Run a default query to gather some information about the site.
  query: "\n    {\n      site {\n        siteMetadata {\n          title\n          description\n          siteUrl\n          site_url: siteUrl\n        }\n      }\n    }\n  ",

  // Setup an RSS object, merging on various feed-specific options.
  setup: function setup(_ref) {
    var _ref$query = _ref.query,
        siteMetadata = _ref$query.site.siteMetadata,
        rest = (0, _objectWithoutProperties3.default)(_ref$query, ["site"]);

    return (0, _extends3.default)({}, siteMetadata, rest);
  },

  // Create a default RSS feed. Others may be added by using the format below.
  feeds: [{
    query: "\n      {\n        allMarkdownRemark(\n          limit: 1000,\n          sort: {\n            order: DESC,\n            fields: [frontmatter___date]\n          }\n        ) {\n          edges {\n            node {\n              frontmatter {\n                title\n                date\n              }\n              fields {\n                slug\n              }\n              excerpt\n              html\n            }\n          }\n        }\n      }\n    ",

    // Where we will save the feed generated by this query.
    output: "rss.xml"
  }]
};
exports.defaultOptions = defaultOptions;


//////////////////
// WEBPACK FOOTER
// ./~/_gatsby-plugin-feed@1.3.20@gatsby-plugin-feed/internals.js
// module id = 260
// module chunks = 0